/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Px } from '../assets/posize';
import HeaderBlack from '../components/HeaderBlack';

export default function SOUL7(props) {
  return (
    <div
      style={{
        '--src': `url(${
          require('assets/f8cfdf2c429cc850e5fc6d816c93715a.png').default
        })`
      }}
      className={`s-ou-l7 ${css(styles.group, styles.group_layout)}`}
    >
      <div className={css(styles.cover_group, styles.cover_group_layout)}>
        <div className={css(styles.flex, styles.flex_layout)}>
          <div className={css(styles.flex_item)}>
            <div className={css(styles.component, styles.component_layout)}>
              <HeaderBlack
                icon={
                  require('assets/d322d14b233070bbff024a1a56d1eb66.png').default
                }
              />
            </div>
          </div>
          <div className={css(styles.flex_item1)}>
            <div
              style={{
                '--src': `url(${
                  require('assets/4822edc7e677fd3b07e00c9e46f38def.png').default
                })`
              }}
              className={css(styles.cover_group1, styles.cover_group1_layout)}
            >
              <div
                style={{
                  '--src': `url(${
                    require('assets/b5589099ce3215c6ad7d36fe4b18fc83.png')
                      .default
                  })`
                }}
                className={css(styles.image, styles.image_layout)}
              />
            </div>
          </div>
          <h4 className={css(styles.highlights, styles.highlights_layout)}>
            {'你/妳的靈魂是'}
          </h4>
          <h1 className={css(styles.big_title, styles.big_title_layout)}>
            {'奢華古典的皇室成員'}
          </h1>
          <div className={css(styles.flex_item2)}>
            <h5 className={css(styles.highlights1, styles.highlights1_layout)}>
              {
                '你為何人見人愛？帶著神秘，卻隱藏不住的與生俱來高貴氣質。甜蜜淡雅的韻味，溫柔而強勢的第一印象，帶有高度的美麗是無需辯論的，不管是男人還是女人都會為之瘋狂。'
              }
            </h5>
          </div>
          <div className={css(styles.flex_item3)}>
            <div
              onClick={() => window.open('/soul', '_self')}
              className={`${css(
                styles.cover_group2,
                styles.cover_group2_layout
              )} cursor-pointer to-more`}
            >
              {'五感靈魂樣貌'}
            </div>
          </div>
          <div className={css(styles.flex_item4)}>
            <div
              style={{
                '--src': `url(${
                  require('assets/cb99bf4081f9a538d19358d130521bba.png').default
                })`
              }}
              className={css(styles.image1, styles.image1_layout)}
            />
          </div>
          <h4 className={css(styles.highlights2, styles.highlights2_layout)}>
            {'專屬於你的風味想像'}
          </h4>
          <div className={css(styles.flex_item5)}>
            <div
              className={css(
                styles.paragraph_body,
                styles.paragraph_body_layout
              )}
            >
              {
                '庭園裡百花盛開，有的和藤蔓協奏跳舞、有的掩映在灑落的噴水簾幕後面。在大理石打造的奢華廊道裡漫步向前，豔麗與清幽錯落著，一個眾人眼中的天堂，充滿香氣的世界。'
              }
            </div>
          </div>
          <h4 className={css(styles.highlights3, styles.highlights3_layout)}>
            {'推薦給你：花火釀的茶・蜜香有機紅烏龍'}
          </h4>
          <div className={css(styles.flex_item6)}>
            <div
              className={css(
                styles.paragraph_body,
                styles.paragraph_body_layout1
              )}
            >
              {
                '總是要為自己留一點奢華時刻，平凡的日子裡，只要你願意慎重對待生活，女皇就將會施施然降臨。'
              }
            </div>
          </div>
          <div className={css(styles.flex_item7)}>
            <div className={css(styles.flex1, styles.flex1_layout)}>
              <div className={css(styles.flex1_item)}>
                <div
                  className={css(
                    styles.cover_group3,
                    styles.cover_group3_layout
                  )}
                >
                  {'風味標籤'}
                </div>
              </div>
              <div className={css(styles.flex1_spacer)} />
              <div
                className={css(
                  styles.small_text_body,
                  styles.small_text_body_layout
                )}
              >
                {'橙花蜂蜜、蜜桃、太妃糖、香草、雞蛋花、甜酒釀'}
              </div>
            </div>
          </div>
          <div className={css(styles.flex_item)}>
            <div className={css(styles.flex2, styles.flex2_layout)}>
              <div className={css(styles.flex2_item)}>
                <div
                  className={css(
                    styles.cover_group4,
                    styles.cover_group4_layout
                  )}
                >
                  <div
                    className={css(
                      styles.small_text_body1,
                      styles.small_text_body1_layout
                    )}
                  >
                    {'茶體'}
                  </div>
                </div>
              </div>
              <div className={css(styles.flex2_spacer)} />
              <div
                className={css(
                  styles.small_text_body,
                  styles.small_text_body_layout1
                )}
              >
                {'飽滿'}
              </div>
              <div className={css(styles.flex2_spacer1)} />
              <div className={css(styles.flex2_item1)}>
                <div className={css(styles.group1, styles.group1_layout)}>
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/7002bbaa139e7d9d211da8230940a637.svg')
                          .default
                      })`
                    }}
                    className={css(styles.decorator, styles.decorator_layout)}
                  />
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/07b246cb08f0056bf96a8effcd0e4dfa.svg')
                          .default
                      })`
                    }}
                    className={css(styles.decorator, styles.decorator_layout1)}
                  />
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/430809e35122bba8c40836246d86d5f4.svg')
                          .default
                      })`
                    }}
                    className={css(styles.decorator, styles.decorator_layout2)}
                  />
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/464f91b9379806cfb80ca83ed573909f.svg')
                          .default
                      })`
                    }}
                    className={css(styles.decorator, styles.decorator_layout3)}
                  />

                  <div className={css(styles.group2, styles.group2_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/af0621239ace26527599934aec7760d2.svg')
                            .default
                        })`
                      }}
                      className={css(styles.img, styles.img_layout)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={css(styles.flex_item9)}>
            <div className={css(styles.flex3, styles.flex3_layout)}>
              <div className={css(styles.flex3_item)}>
                <div
                  className={css(
                    styles.cover_group5,
                    styles.cover_group5_layout
                  )}
                >
                  <div
                    className={css(
                      styles.small_text_body3,
                      styles.small_text_body3_layout
                    )}
                  >
                    {'泡法'}
                  </div>
                </div>
              </div>
              <div className={css(styles.flex3_spacer)} />
              <div className={css(styles.flex3_item1)}>
                <div className={css(styles.flex4, styles.flex4_layout)}>
                  <div className={css(styles.flex4_item)}>
                    <div className={css(styles.flex5, styles.flex5_layout)}>
                      <div
                        style={{
                          '--src': `url(${
                            require('assets/8256fb8e4c4e8d1cbccf18b12b20b940.png')
                              .default
                          })`
                        }}
                        className={css(styles.image, styles.image_layout1)}
                      />
                      <div className={css(styles.flex5_spacer)} />
                      <div
                        className={css(
                          styles.small_text_body4_box,
                          styles.small_text_body4_box_layout
                        )}
                      >
                        <div className={css(styles.small_text_body4)}>
                          <span className={css(styles.small_text_body4_span0)}>
                            {'200ml'}
                          </span>
                          <span className={css(styles.small_text_body4_span1)}>
                            {' 熱泡'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={css(
                      styles.small_text_body5_box,
                      styles.small_text_body5_box_layout
                    )}
                  >
                    <div className={css(styles.small_text_body5)}>
                      <span className={css(styles.small_text_body5_span0)}>
                        {'茶葉 '}
                      </span>
                      <span className={css(styles.small_text_body5_span1)}>
                        {'3g'}
                      </span>
                      <span className={css(styles.small_text_body5_span2)}>
                        {' / 茶包'}
                      </span>
                      <span className={css(styles.small_text_body5_span3)}>
                        {'1'}
                      </span>
                      <span className={css(styles.small_text_body5_span4)}>
                        {'個'}
                      </span>
                    </div>
                  </div>
                  <div
                    className={css(
                      styles.small_text_body6_box,
                      styles.small_text_body6_box_layout
                    )}
                  >
                    <div className={css(styles.small_text_body6)}>
                      <span className={css(styles.small_text_body6_span0)}>
                        {'水溫：'}
                      </span>
                      <span className={css(styles.small_text_body6_span1)}>
                        {'95-98°C'}
                      </span>
                    </div>
                  </div>
                  <div
                    className={css(
                      styles.small_text_body7_box,
                      styles.small_text_body7_box_layout
                    )}
                  >
                    <div className={css(styles.small_text_body7)}>
                      <span className={css(styles.small_text_body7_span0)}>
                        {'時間：'}
                      </span>
                      <span className={css(styles.small_text_body7_span1)}>
                        {'2'}
                      </span>
                      <span className={css(styles.small_text_body7_span2)}>
                        {'分鐘'}
                      </span>
                    </div>
                  </div>
                  <div
                    className={css(
                      styles.small_text_body8_box,
                      styles.small_text_body8_box_layout
                    )}
                  >
                    <div className={css(styles.small_text_body8)}>
                      <span className={css(styles.small_text_body8_span0)}>
                        {'回沖：'}
                      </span>
                      <span className={css(styles.small_text_body8_span1)}>
                        {'3'}
                      </span>
                      <span className={css(styles.small_text_body8_span2)}>
                        {'次'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={css(styles.flex3_spacer1)} />
              <div className={css(styles.flex3_item2)}>
                <div className={css(styles.flex6, styles.flex6_layout)}>
                  <div className={css(styles.flex6_item)}>
                    <div className={css(styles.flex7, styles.flex7_layout)}>
                      <div
                        style={{
                          '--src': `url(${
                            require('assets/cad9bcf9ad1371a1a2b9462ed3feb802.png')
                              .default
                          })`
                        }}
                        className={css(styles.image, styles.image_layout2)}
                      />
                      <div className={css(styles.flex7_spacer)} />
                      <div
                        className={css(
                          styles.small_text_body9_box,
                          styles.small_text_body9_box_layout
                        )}
                      >
                        <div className={css(styles.small_text_body9)}>
                          <span className={css(styles.small_text_body9_span0)}>
                            {'300ml'}
                          </span>
                          <span className={css(styles.small_text_body9_span1)}>
                            {' 熱泡'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={css(
                      styles.small_text_body10_box,
                      styles.small_text_body10_box_layout
                    )}
                  >
                    <div className={css(styles.small_text_body10)}>
                      <span className={css(styles.small_text_body10_span0)}>
                        {'茶葉 '}
                      </span>
                      <span className={css(styles.small_text_body10_span1)}>
                        {'3g'}
                      </span>
                      <span className={css(styles.small_text_body10_span2)}>
                        {' / 茶包'}
                      </span>
                      <span className={css(styles.small_text_body10_span3)}>
                        {'1'}
                      </span>
                      <span className={css(styles.small_text_body10_span4)}>
                        {'個'}
                      </span>
                    </div>
                  </div>
                  <div
                    className={css(
                      styles.small_text_body11_box,
                      styles.small_text_body11_box_layout
                    )}
                  >
                    <div className={css(styles.small_text_body11)}>
                      <span className={css(styles.small_text_body11_span0)}>
                        {'水溫：'}
                      </span>
                      <span className={css(styles.small_text_body11_span1)}>
                        {'95-98°C'}
                      </span>
                    </div>
                  </div>
                  <div
                    className={css(
                      styles.small_text_body12_box,
                      styles.small_text_body12_box_layout
                    )}
                  >
                    <div className={css(styles.small_text_body12)}>
                      <span className={css(styles.small_text_body12_span0)}>
                        {'時間：'}
                      </span>
                      <span className={css(styles.small_text_body12_span1)}>
                        {'3'}
                      </span>
                      <span className={css(styles.small_text_body12_span2)}>
                        {'分鐘'}
                      </span>
                    </div>
                  </div>
                  <div
                    className={css(
                      styles.small_text_body13_box,
                      styles.small_text_body13_box_layout
                    )}
                  >
                    <div className={css(styles.small_text_body13)}>
                      <span className={css(styles.small_text_body13_span0)}>
                        {'回沖'}
                      </span>
                      <span className={css(styles.small_text_body13_span1)}>
                        {'：'}
                      </span>
                      <span className={css(styles.small_text_body13_span2)}>
                        {'2'}
                      </span>
                      <span className={css(styles.small_text_body13_span3)}>
                        {'次'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={css(styles.flex_item10)}>
            <div
              onClick={() =>
                window.open(
                  'https://www.daughter-tea.com/product.aspx?openExternalBrowser=1&Id=10'
                )
              }
              className={`${css(
                styles.cover_group6,
                styles.cover_group6_layout
              )} cursor-pointer to-more`}
            >
              {'了解更多'}
            </div>
          </div>
          <div className={css(styles.flex_item11)}>
            <div
              onClick={() => window.open('/', '_self')}
              className={`${css(
                styles.cover_group7,
                styles.cover_group7_layout
              )} cursor-pointer to-home`}
            >
              <div
                className={css(styles.background, styles.background_layout)}
              />
              <h5
                className={css(styles.highlights4, styles.highlights4_layout)}
              >
                {'重新探索'}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SOUL7.inStorybook = true;

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    backgroundColor: 'rgb(255,255,255)'
  },
  group_layout: {
    position: 'relative',
    minHeight: 1571,
    flexGrow: 1
  },
  cover_group: {
    display: 'flex',
    backgroundColor: 'rgb(254,240,238)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group_layout: {
    position: 'relative',
    width: 375,
    minWidth: 375,
    margin: '0px auto'
  },
  flex: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '53px 15px'
  },
  flex_item: {
    display: 'flex',
    flex: '0 1 30px'
  },
  component: {},
  component_layout: {
    minHeight: 29,
    flexGrow: 1,
    margin: '1px 12px 0px 1px'
  },
  flex_item1: {
    display: 'flex',
    flex: '0 1 297px'
  },
  cover_group1: {
    display: 'flex',
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group1_layout: {
    position: 'relative',
    minHeight: 257,
    flexGrow: 1,
    margin: '40px 1px 0px'
  },
  image: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image_layout: {
    height: 134,
    width: 82,
    minWidth: 82,
    margin: '38px auto 85px'
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    font: '18px/1.79 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px',
    opacity: 0.69875
  },
  highlights_layout: {
    flex: '1 0 auto',
    margin: '15px 1px 0px'
  },
  big_title: {
    display: 'flex',
    alignItems: 'center',
    font: '500 30px/1.8 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  big_title_layout: {
    flex: '1 0 auto',
    margin: '8px 1px 0px'
  },
  flex_item2: {
    display: 'flex',
    flex: '0 1 134px'
  },
  highlights1: {
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights1_layout: {
    flexGrow: 1,
    margin: '22px 1px 0px'
  },
  flex_item3: {
    display: 'flex',
    flex: '0 1 58px'
  },
  cover_group2: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cover_group2_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '14px 1px 0px'
  },
  flex_item4: {
    display: 'flex',
    flex: '0 1 298px'
  },
  image1: {
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  image1_layout: {
    height: 257,
    flexGrow: 1,
    margin: '41px 0px 0px 1px'
  },
  highlights2: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights2_layout: {
    flex: '1 0 auto',
    margin: '21px 1px 0px'
  },
  flex_item5: {
    display: 'flex',
    flex: '0 1 95px'
  },
  paragraph_body: {
    font: '14px/1.57 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  paragraph_body_layout: {
    flexGrow: 1,
    margin: '7px 1px 0px'
  },
  highlights3: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights3_layout: {
    flex: '1 0 auto',
    margin: '45px 1px 0px'
  },
  flex_item6: {
    display: 'flex',
    flex: '0 1 59px'
  },
  paragraph_body_layout1: {
    flexGrow: 1,
    margin: '15px 1px 0px'
  },
  flex_item7: {
    display: 'flex',
    flex: '0 1 36px'
  },
  flex1: {
    display: 'flex'
  },
  flex1_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex1_item: {
    display: 'flex',
    flex: '0 1 60px'
  },
  cover_group3: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    justifyContent: 'flex-end',
    padding: '0px 5px 0px 5px'
  },
  cover_group3_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '16px 0px 0px 1px'
  },
  flex1_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  small_text_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body_layout: {
    flex: '1 1 auto',
    margin: '16px 0px 0px'
  },
  flex2: {
    display: 'flex'
  },
  flex2_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex2_item: {
    display: 'flex',
    flex: '0 1 60px'
  },
  cover_group4: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group4_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '10px 0px 0px 1px'
  },
  small_text_body1: {
    display: 'flex',
    justifyContent: 'flex-end',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'right',
    letterSpacing: '0px'
  },
  small_text_body1_layout: {
    width: 25,
    minWidth: 25,
    margin: '0px auto'
  },
  flex2_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  small_text_body_layout1: {
    margin: '10px 0px 0px'
  },
  flex2_spacer1: {
    flex: '0 0 auto',
    minWidth: 9
  },
  flex2_item1: {
    display: 'flex',
    flex: '0 1 244px'
  },
  group1: {
    display: 'flex'
  },
  group1_layout: {
    position: 'relative',
    height: 18,
    width: 65,
    minWidth: 65,
    margin: '11px 0px 1px'
  },
  decorator: {
    background: 'var(--src) center center / contain no-repeat'
  },
  decorator_layout: {
    position: 'absolute',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px',
    inset: '0px auto auto 0px'
  },
  decorator_layout1: {
    position: 'absolute',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px auto',
    inset: '0px 0px auto'
  },
  decorator_layout2: {
    position: 'absolute',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px',
    inset: '0px auto auto 13px'
  },
  decorator_layout3: {
    position: 'absolute',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px',
    inset: '0px 13px auto auto'
  },
  group2: {
    display: 'flex',
    opacity: 0.2047374636627907
  },
  group2_layout: {
    position: 'absolute',
    width: 14,
    minWidth: 14,
    inset: '0px 0px 0px auto'
  },
  img: {
    background: 'var(--src) center center / cover no-repeat'
  },
  img_layout: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 0px 1px'
  },
  flex_item9: {
    display: 'flex',
    flex: '0 1 110px'
  },
  flex3: {
    display: 'flex'
  },
  flex3_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex3_item: {
    display: 'flex',
    flex: '0 1 60px'
  },
  cover_group5: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group5_layout: {
    position: 'relative',
    height: 'min-content',
    minHeight: 20,
    flexGrow: 1,
    margin: '10px 0px 0px 1px'
  },
  small_text_body3: {
    display: 'flex',
    justifyContent: 'flex-end',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'right',
    letterSpacing: '0px'
  },
  small_text_body3_layout: {
    width: 25,
    minWidth: 25,
    margin: '0px auto'
  },
  flex3_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  flex3_item1: {
    display: 'flex',
    flex: '0 1 94px'
  },
  flex4: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex4_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '10px 0px 0px'
  },
  flex4_item: {
    display: 'flex',
    flex: '0 1 20px'
  },
  flex5: {
    display: 'flex'
  },
  flex5_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image_layout1: {
    flex: '0 1 18px',
    height: 11,
    width: 18,
    minWidth: 18,
    margin: '5px 0px 4px'
  },
  flex5_spacer: {
    flex: '0 0 auto',
    minWidth: 5
  },
  small_text_body4: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body4_box: {},
  small_text_body4_box_layout: {
    flex: '1 1 auto'
  },
  small_text_body4_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body4_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body5_box: {},
  small_text_body5_box_layout: {
    flex: '0 0 auto'
  },
  small_text_body5_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body6_box: {},
  small_text_body6_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body6_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body7: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body7_box: {},
  small_text_body7_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body7_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body7_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body7_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body8_box: {},
  small_text_body8_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body8_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex3_spacer1: {
    flex: '0 0 auto',
    minWidth: 30
  },
  flex3_item2: {
    display: 'flex',
    flex: '0 1 153px'
  },
  flex6: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex6_layout: {
    position: 'relative',
    width: 94,
    minWidth: 94,
    margin: '10px 0px 0px'
  },
  flex6_item: {
    display: 'flex',
    flex: '0 1 20px'
  },
  flex7: {
    display: 'flex'
  },
  flex7_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image_layout2: {
    flex: '0 1 18px',
    height: 13,
    width: 18,
    minWidth: 18,
    margin: '4px 0px 3px'
  },
  flex7_spacer: {
    flex: '0 0 auto',
    minWidth: 5
  },
  small_text_body9: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body9_box: {},
  small_text_body9_box_layout: {
    flex: '1 1 auto'
  },
  small_text_body9_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body9_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body10_box: {},
  small_text_body10_box_layout: {
    flex: '0 0 auto'
  },
  small_text_body10_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body11_box: {},
  small_text_body11_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body11_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body12: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body12_box: {},
  small_text_body12_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body12_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body12_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body12_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body13: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body13_box: {},
  small_text_body13_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body13_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body13_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body13_span2: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body13_span3: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex_item10: {
    display: 'flex',
    flex: '0 1 56px'
  },
  cover_group6: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cover_group6_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '12px 1px 0px'
  },
  flex_item11: {
    display: 'flex',
    flex: '0 1 60px'
  },
  cover_group7: {
    display: 'flex'
  },
  cover_group7_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '16px 1px 0px'
  },
  background: {
    border: '1px solid rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  background_layout: {
    position: 'absolute',
    height: 44,
    flexGrow: 1,
    inset: '0px 0px auto'
  },
  highlights4: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(94,117,111)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights4_layout: {
    flexGrow: 1,
    margin: '8px 0px'
  }
});
